<template>
  <b-card style="padding:40px;">
    <h5><b>MONTHLY FORECAST</b></h5>
    <hr />

    <div>
      <b-row>
        <b-col md="3">
          <b-form-group>
            <label :for="`input-year`">Year</label>
            <b-input v-model="form.year" class="input-new" required disabled />
          </b-form-group>
        </b-col>

        <!-- Display Month -->
        <b-col md="3">
          <b-form-group>
            <label :for="`input-month`">Month</label>
            <b-input
              :value="getMonth(form.month)"
              class="input-new"
              required
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <b-row class="my-1">
        <b-col md="8">
          <label for="input-default"
            >Product Name<span class="danger-new"> *</span></label
          >
          <multiselect
            v-model="input.product_name"
            :options="product_name"
            :custom-label="nameWithSKU"
            placeholder="Please select"
            label="name"
            track-by="name"
          ></multiselect>
          <p v-if="error.product_name">
            <span class="danger-new">{{ this.error.product_name }}</span>
          </p>
        </b-col> </b-row
      ><br />
      <b-row>
        <b-col md="3">
          <label for="input-default"
            >Quantity<span class="danger-new"> *</span></label
          >
          <b-form-input
            v-model="input.qty"
            id="input-horizontal"
            class="input-new"
          ></b-form-input>
          <p v-if="error.qty">
            <span class="danger-new">{{ this.error.qty }}</span>
          </p>
        </b-col>

        <b-col md="3">
          <label for="input-default"
            >Quantity Type<span class="danger-new"> *</span></label
          >
          <b-form-select
            v-model="input.qtyType"
            :options="dropdown.qtyType"
            id="input-horizontal"
            required
            class="input-new"
          />
        </b-col>

        <b-col md="3">
          <label for="input-week">Week<span class="danger-new"> *</span></label>
          <b-form-select
            v-model="input.weeks"
            :options="select.weeks"
            class="input-new"
            required
          ></b-form-select>
        </b-col>

        <b-col md="2" style="padding-top:27px;">
          <b-button variant="primary" size="m" @click="onClickAdd">+</b-button>
          &nbsp;&nbsp;&nbsp;
          <b-button variant="danger" size="m">x</b-button>
        </b-col>
      </b-row>

      <br />

      <b-tabs v-model="tabIndex" content-class="mt-3">
        <b-tab title="Week 1" active>
          <br />
          <TableMonthlyForecastEdit
            @delete="deleteItem($event)"
            :fields="fields"
            :items="items.data1"
            :week="1"
          />
        </b-tab>

        <b-tab title="Week 2">
          <br />
          <TableMonthlyForecastEdit
            @delete="deleteItem($event)"
            :fields="fields"
            :items="items.data2"
            :week="2"
          />
        </b-tab>

        <b-tab title="Week 3">
          <br />
          <TableMonthlyForecastEdit
            @delete="deleteItem($event)"
            :fields="fields"
            :items="items.data3"
            :week="3"
          />
        </b-tab>
        <b-tab title="Week 4">
          <br />
          <TableMonthlyForecastEdit
            @delete="deleteItem($event)"
            :fields="fields"
            :items="items.data4"
            :week="4"
          />
        </b-tab>
        <b-tab title="Week 5">
          <br />
          <TableMonthlyForecastEdit
            @delete="deleteItem($event)"
            :fields="fields"
            :items="items.data5"
            :week="5"
          />
        </b-tab>

        <b-row align="right">
          <b-col>
            <b-button variant="primary" size="sm" @click="onClickBack">
              BACK </b-button
            >&nbsp;&nbsp;&nbsp;
            <b-button variant="primary" size="sm" @click="onClickPreview"
              >PREVIEW</b-button
            >
          </b-col>
        </b-row>
      </b-tabs>
    </div>
  </b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import TableMonthlyForecastEdit from "@/table/user/monthlyForecast/TableMonthlyForecastEdit";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import Failed from "@/pages/Notifications/Failed";
import moment from "moment";

export default {
  data() {
    return {
      form: {
        id: "",
        items: "",
        category: "",
        year: "",
        month: "",
        type: "",
        proCat: ""
      },
      date_week1: "",
      items: {
        data1: [],
        data2: [],
        data3: [],
        data4: [],
        data5: []
      },
      selected: null,
      product_name: [],
      input: {
        pro_stock_id: null,
        product_name: "",
        qty: "",
        weeks: "1",
        qtyType: "1"
      },
      dropdown: {
        qtyType: [
          { text: "Pcs", value: "1" },
          { text: "Ctn", value: "2" }
        ]
      },
      error: {
        product_name: "",
        qty: ""
      },

      tabIndex: 0,

      select: {
        // week
        weeks: [
          { text: "Week 1", value: "1" },
          { text: "Week 2", value: "2" },
          { text: "Week 3", value: "3" },
          { text: "Week 4", value: "4" },
          { text: "Week 5", value: "5" }
        ]
      },

      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Quantity Type",
          key: "quantity_type",
          sortable: true
        },
        {
          label: "Action",
          key: "action",
          sortable: false
        }
      ]
    };
  },
  created() {
    this.getProduct();
    // let type = JSON.parse(this.$route.query.type);

    if (this.$route.query.type === "new") {
      this.form.month = moment(this.$route.query.month).format("MM");

      this.form.year = moment(this.$route.query.year).year();

      let currentDate = moment().format("YYYY-MM");
      let targetDate = moment(
        this.form.year + "-" + this.form.month + "-01"
      ).format("YYYY-MM-DD");

      const diffInMonths = moment(targetDate).diff(
        moment(currentDate + "-01"),
        "months",
        true
      ); // true gives float

      const isLessThanThreeMonths = diffInMonths < 4;

      if (isLessThanThreeMonths) {
        this.createForecast();
      } else {
        alert("Cannot create Monthly Forecast for more than 3 months!");
        this.$router.push({
          path: `mf_user`
        });
      }
    } else {
      this.showMF();
    }

    this.form.proCat = this.$route.query.pro_cat;

    this.form.type =
      parseInt(this.$route.query.pro_cat) === 1 ? "UHT" : "Pasteurized";
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    onClickAdd() {
      this.error.product_name = "";
      this.error.qty = "";

      this.checkForm();

      let data = "";

      if (this.input.weeks === "1") {
        data = this.items.data1;
      } else if (this.input.weeks === "2") {
        data = this.items.data2;
      } else if (this.input.weeks === "3") {
        data = this.items.data3;
      } else if (this.input.weeks === "4") {
        data = this.items.data4;
      } else if (this.input.weeks === "5") {
        data = this.items.data5;
      }

      let product;

      if (this.input.pro_stock_id !== null) {
        product = {
          fc_id: this.$route.query.id,
          quantity: this.input.qty,
          quantity_type: this.input.qtyType,
          product_id: this.input.product_name.sku,
          week: this.input.weeks,
          index: String(this.input.product_name.index),
          pro_stock_id: this.input.pro_stock_id ? this.input.pro_stock_id : null
        };
      } else {
        product = {
          fc_id: this.form.id,
          quantity: this.input.qty,
          quantity_type: this.input.qtyType,
          product_id: this.input.product_name.sku,
          index: String(this.input.product_name.index),
          week: this.input.weeks,
          pro_stock_id: this.input.pro_stock_id ? this.input.pro_stock_id : null
        };
      }

      this.$store.dispatch("createWeekMF", product).then(res => {
        if (res.data.response.code === 1) {
          this.$notify({
            component: NotificationTemplate,
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });

          data.push({
            isActive: true,
            pro_stock_id: res.data.data.pro_stock_id,
            name: this.input.product_name.name,
            sku: this.input.product_name.sku,
            index: String(this.input.product_name.index),
            quantity: this.input.qty,
            quantity_type: parseInt(this.input.qtyType) === 1 ? "Pcs" : "Ctn",
            action: "fas fa-user"
          });

          this.tabIndex = parseInt(this.input.weeks) - 1;
          this.input.product_name = "";
          this.input.qty = "";
        } else {
          this.$notify({
            component: Failed,
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        }
      });
    },

    getProduct() {
      let param = "?type=" + this.$route.query.pro_cat;
      this.$store.dispatch("getProduct", param).then(res => {
        res.data.data.forEach((element, index) => {
          this.product_name.push({
            sku: element.product_id,
            name: element.name,
            index: index
          });
        });
      });
    },
    nameWithSKU({ name, sku }) {
      return `${name} — [${sku}]`;
    },

    // Delete Item
    deleteItem(param) {
      let data = "";

      if (param.week === "1") {
        data = this.items.data1;
      } else if (param.week === "2") {
        data = this.items.data2;
      } else if (param.week === "3") {
        data = this.items.data3;
      } else if (param.week === "4") {
        data = this.items.data4;
      } else if (param.week === "5") {
        data = this.items.data5;
      }

      this.$store
        .dispatch("deleteProMF", data[param.index].pro_stock_id)
        .then(res => {
          if (res.data.response.code === 1) {
            data.splice(param.index, 1);
          }
        });
    },

    // Preview
    onClickPreview() {
      if (this.items.length < 1) {
        this.checkForm();
      }
      // this.form.category = this.cat;
      // this.form.items = this.items;
      const data = JSON.stringify(this.form);
      this.$router.push({ path: `mf_submit?data=${data}` });
    },
    checkForm: function(e) {
      if (this.input.qty && this.input.product_name) return true;
      this.error.product_name = "";
      this.error.qty = "";
      if (!this.input.product_name)
        this.error.product_name = "Product Name required.";
      if (!this.input.qty) this.error.qty = "Quantity required.";
      e.preventDefault();
    },

    getMonth(month) {
      switch (parseInt(month)) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },

    // create monthly forecast
    createForecast() {
      this.$store
        .dispatch("createForecast", {
          year: this.form.year,
          month: parseInt(this.form.month),
          type: parseInt(this.$route.query.pro_cat)
        })
        .then(res => {
          if (res.data.response.code === 1) {
            this.form.id = res.data.data.fc_id;
          }
        })
        .catch(() => {
          alert(
            "You have created Monthly Forecast for next month or same product category!"
          );
          this.$router.push({
            path: `mf_user`
          });
        });
    },

    showMF() {
      this.$store
        .dispatch("showMF", {
          fc_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            // get id
            this.form.id = res.data.data.fc_id;
            // get month
            this.form.month = res.data.data.month;
            // get year
            this.form.year = res.data.data.year;

            if (
              res.data.data.fc_week.length > 1 ||
              res.data.data.fc_week !== undefined
            ) {
              let week = res.data.data.fc_week;
              week.forEach(item => {
                // Week 1
                if (item.week === 1) {
                  let week1 = [];
                  item.pro_stock.forEach(item2 => {
                    week1.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data1 = week1;
                }

                // Week 2
                if (item.week === 2) {
                  let week2 = [];
                  item.pro_stock.forEach(item2 => {
                    week2.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data2 = week2;
                }

                // Week 3
                if (item.week === 3) {
                  let week3 = [];
                  item.pro_stock.forEach(item2 => {
                    week3.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data3 = week3;
                }

                // Week 4
                if (item.week === 4) {
                  let week4 = [];
                  item.pro_stock.forEach(item2 => {
                    week4.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data4 = week4;
                }

                // Week 5
                if (item.week === 5) {
                  let week5 = [];
                  item.pro_stock.forEach(item2 => {
                    week5.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data5 = week5;
                }
              });
            }
          }
        });
    }
  },
  components: {
    Multiselect,
    TableMonthlyForecastEdit
  }
};
</script>
<style lang="css" scoped></style>
